import { request } from 'graphql-request';
import { FaPray } from 'react-icons/fa';
import form from '../components/form/form';

import { FormData, ContactUsFormData } from '../models/dataTypes/formData';

export class OptInService {
    private baseUrl = process.env.PUBLIC_FUNCTION_BASE_URL as string;

    submitForm(
        formData: FormData | null,
        dispensaryUniqueId?: string | null,
        err?: boolean
    ): Promise<[boolean, null]> | [boolean, null] {
        if (!formData || err) {
            return [false, null];
        } else {
            const params = {
                dispensaryUniqueId,
                eventName: formData.eventName,
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                phone: formData.phone,
                state: formData.state,
                dispensary: formData.dispensary,
                cardStatus: formData.cardStatus,
                optInMethod: formData.optInMethod,
                optIn: true
            };

            const query = `mutation FormQuery (
                $dispensaryUniqueId: String
                $eventName: String!
                $firstName: String!
                $lastName: String!
                $email: String!
                $phone: String
                $state: String!
                $dispensary: String
                $cardStatus: String!
                $optInMethod: [String]!
                ){
                submitForm(
                    dispensaryUniqueId: $dispensaryUniqueId,
                    eventName: $eventName,
                    formData: {
                        firstName: $firstName,
                        lastName: $lastName,
                        email: $email,
                        phone: $phone,
                        state: $state,
                        dispensary: $dispensary,
                        cardStatus: $cardStatus,
                        optInMethod: $optInMethod,
                        optIn: true
                    },
                ) {
                    success
                    error
                }
            }`;

            return request(`${this.baseUrl}/SubmitForm?`, query, params)
                .then((data: any): [boolean, null] => [
                    data && data.submitForm && data.submitForm.success,
                    null
                ])
                .catch(err => {
                    // eslint-disable-next-line no-console
                    console.error(err);
                    return [false, null];
                });
        }
    }

    public submitContactForm(formData?: ContactUsFormData, err?: boolean): Promise<[boolean, null]> | [boolean, null] {
        if (!formData || err) {
            return [false, null]
        } else {
            const params = {
                eventName: formData.eventName,
                firstName: formData.firstName,
                lastName: formData.lastName,
                email: formData.email,
                phone: formData.phone,
                state: formData.state,
                dispensary: formData.dispensary,
                optIn: true,
                topic: formData.topic,
                topicDescription: formData.topicDescription
            };
    
            const query = `mutation FormQuery (
                $eventName: String!
                $firstName: String!
                $lastName: String!
                $email: String!
                $phone: String
                $state: String
                $dispensary: String
                $optIn: Boolean
                $topic: String!
                $topicDescription: String!
                ){
                submitContactUsForm(
                    eventName: $eventName,
                    formData: {
                        firstName: $firstName,
                        lastName: $lastName,
                        email: $email,
                        phone: $phone,
                        state: $state,
                        dispensary: $dispensary,
                        optIn: $optIn,
                        topic: $topic,
                        topicDescription: $topicDescription
                    },
                ) {
                    success
                    error
                }
            }`;

            return request(`${this.baseUrl}/SubmitForm?`, query, params)
                .then((data: any): [boolean, null] => {
                    console.log({data})
                    return [
                    data && data.submitContactUsForm && data.submitContactUsForm.success,
                    null
                ]
            })
                .catch(err => {
                    // eslint-disable-next-line no-console
                    console.error(err);
                    return [false, null];
                });
        }
    }
}
